import { createTranslations } from '@npco/common-utils-translations'

export const outstandingTransactionsComingSoonModalContentTranslations =
  createTranslations({
    title: 'Corporate Card Settings',
    description:
      'Define outstanding expense categorisation and customise logos for physical cards. Coming soon to Zeller Dashboard.',
    actionButton: 'Got it',
  })
